import { render, staticRenderFns } from "./modalClosure.vue?vue&type=template&id=3bc93c8d&scoped=true"
import script from "./modalClosure.vue?vue&type=script&lang=js"
export * from "./modalClosure.vue?vue&type=script&lang=js"
import style0 from "./modalClosure.vue?vue&type=style&index=0&id=3bc93c8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc93c8d",
  null
  
)

export default component.exports